import { render, staticRenderFns } from "./pipma.vue?vue&type=template&id=5102c9bf&scoped=true&"
import script from "./pipma.vue?vue&type=script&lang=js&"
export * from "./pipma.vue?vue&type=script&lang=js&"
import style0 from "./pipma.vue?vue&type=style&index=0&id=5102c9bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5102c9bf",
  null
  
)

export default component.exports